// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__j9uv8","header":"PatientBlock_header__1Cn-X","label":"PatientBlock_label__38Ns8","option":"PatientBlock_option__bMRt2"};